export const inr = (n) => {
  const v = Number.isFinite(n) ? n : 0;
  return `₹${v.toLocaleString('en-IN')}`;
};

export const classNames = (...xs) => xs.filter(Boolean).join(' ');
